export const getSelectedRecipient = state => state.selectedRecipient;
